(() => {
  'use strict';

  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  function initCarousel(root) {
    if (!root || root.dataset.carouselInitialized === 'true') return;

    const track = root.querySelector('.dp-track');
    const slides = root.querySelectorAll('.dp-slide');
    const dots = root.querySelectorAll('.dp-dot');
    const prev = root.querySelector('.dp-prev');
    const next = root.querySelector('.dp-next');

    if (!track || slides.length === 0 || !prev || !next) return;

    let index = 0;
    let hover = false;
    let timer;
    let inView = true;

    const autoplayEnabled = root.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(root.dataset.autoplayDelay, 10) || 7000;
    const limitAutoplay = root.dataset.limitAutoplay === 'true';
    const motionQuery = window.matchMedia ? window.matchMedia(REDUCED_MOTION_QUERY) : null;

    function updateDots() {
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    function go(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translateX(${-index * 100}%)`;
      updateDots();
    }

    function stop(release = true) {
      if (timer) {
        clearInterval(timer);
        timer = undefined;
      }
      if (release && limitAutoplay && window._tccAutoplayTaken === root) {
        window._tccAutoplayTaken = null;
      }
    }

    function play() {
      stop(false);
      if (!autoplayEnabled || slides.length < 2) return;
      if (!inView) return;
      if (motionQuery && motionQuery.matches) return;
      if (limitAutoplay && window._tccAutoplayTaken && window._tccAutoplayTaken !== root) return;

      if (limitAutoplay) {
        window._tccAutoplayTaken = root;
      }

      timer = window.setInterval(() => {
        if (!hover) go(index + 1);
      }, autoplayDelay);
    }

    prev.addEventListener('click', () => {
      go(index - 1);
      play();
    });

    next.addEventListener('click', () => {
      go(index + 1);
      play();
    });

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        go(dotIndex);
        play();
      });
    });

    root.addEventListener('mouseenter', () => {
      hover = true;
    });

    root.addEventListener('mouseleave', () => {
      hover = false;
    });

    if (motionQuery) {
      const motionHandler = () => {
        stop();
        if (!motionQuery.matches && inView) play();
      };
      if (typeof motionQuery.addEventListener === 'function') {
        motionQuery.addEventListener('change', motionHandler);
      } else if (typeof motionQuery.addListener === 'function') {
        motionQuery.addListener(motionHandler);
      }
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target !== root) return;
            inView = entry.isIntersecting;
            if (inView) {
              play();
            } else {
              stop();
            }
          });
        },
        { threshold: 0.25, rootMargin: '0px 0px 200px 0px' }
      );
      observer.observe(root);
    }

    const visibilityHandler = () => {
      if (document.visibilityState === 'hidden') {
        stop();
      } else if (inView) {
        play();
      }
    };
    document.addEventListener('visibilitychange', visibilityHandler);

    go(0);
    play();

    root.dataset.carouselInitialized = 'true';
  }

  function initAllCarousels(context = document) {
    context.querySelectorAll('.dp-slider').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllCarousels());
  } else {
    initAllCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllCarousels(event.target);
  });
})();
